/**
 * Helpers para identificar rotas relacionadas a tutoriais
 */

export function isTutorialRoute(pathname: string): boolean {
  const normalizedPath = pathname.replace(/\/$/, '') || '/';

  const exactTutorialRoutes = [
    '/tutoriais',
    '/retaguarda-tutoriais',
    '/conveniencia-tutoriais',
    '/dashboard-tutoriais',
    '/pista-tutoriais',
    '/video-tutoriais',
    '/PDV',
    '/Dashboard',
    '/prevenda',
    '/FaturaWeb',
    '/lukos-pay',
    '/Conveniencia',
    '/pista',
    '/paginatutorial',
    '/cadastros',
    '/Retaguarda',
    '/Fatura Web',
  ];

  if (exactTutorialRoutes.includes(normalizedPath)) return true;

  const tutorialPatterns = [
    /^\/tutoriais\//,
    /^\/tutorial\//,
    /^\/categoria\//,
    /^\/video-tutorial\//,
    /^\/tutorial\/.*\/executar/,
  ];

  for (const pattern of tutorialPatterns) {
    if (pattern.test(normalizedPath)) return true;
  }

  return false;
}

export function shouldShowCategoryNavbar(pathname: string): boolean {
  return isTutorialRoute(pathname);
}

export function shouldShowPageNavbar(pathname: string): boolean {
  if (pathname === '/lukos' || pathname === '/apps' || pathname === '/contato') return false;
  if (pathname.startsWith('/funcionalidades/')) return false;
  return !isTutorialRoute(pathname);
}
